import React from 'react';
import { Pill, Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import { LEDGER_CLEAR_FILTERS_LABEL } from '../../common/ledgerTable/ledgerTable.constants';
import styles from './styles/reports-active-filters.module.scss';

/**
 * The active filters, visible as chips, with one "Clear filters" action.
 * Renders nothing when no filter is set. Labels arrive ready-made from the
 * controller (`getActiveTransactionFilterChips`), so this stays presentational.
 * A `<section>` rather than a div so the `aria-label` is actually announced —
 * a label on a generic element is not.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.chips
 * @param {() => void} props.onClear
 */
function ReportsActiveFilters({ chips, onClear }) {
    if (!chips?.length) return null;

    return (
        <section className={styles.container} aria-label="Active filters">
            <div className={styles.chips}>
                {chips.map((chip) => (
                    <Pill
                        key={chip.key}
                        label={chip.label}
                    />
                ))}
            </div>
            <Button
                hierarchy={ButtonHierarchies.SECONDARY}
                onClick={() => onClear?.()}
            >
                {LEDGER_CLEAR_FILTERS_LABEL}
            </Button>
        </section>
    );
}

export default ReportsActiveFilters;
